// import {
//   Box,
//   Chip,
//   IconButton,
//   Menu,
//   MenuItem,
//   Stack
// } from '@mui/material';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
// import { useState, useRef, useEffect } from 'react';
// import {baseURL} from "../Constant";
// import axios from 'axios';

// const LogoSelection = ({ selectedLogos, setSelectedLogos }) => {
//   const [anchorEl, setAnchorEl] = useState(null);
//   const boxRef = useRef(null);
//   const [logos, setLogos] = useState([]);

//   const handleIconClick = () => {
//     setAnchorEl(prev => (prev ? null : boxRef.current)); // Toggle dropdown
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//   };

//   const handleSelect = (logo) => {
//     const exists = selectedLogos.some(s => s.stored_filename === logo.stored_filename);
//     if (!exists) {
//       setSelectedLogos([...selectedLogos, logo]);
//     }
//   };

//   const handleDelete = (id) => {
//     setSelectedLogos(selectedLogos.filter(sig => sig.stored_filename !== id));
//   };

//   const handleDragEnd = (result) => {
//     if (!result.destination) return;
//     const updated = [...selectedLogos];
//     const [moved] = updated.splice(result.source.index, 1);
//     updated.splice(result.destination.index, 0, moved);
//     setSelectedLogos(updated);
//   };

//   async function getAllLogos() {
//       const res = await axios.get(`${baseURL}/pptx/logos`);   
//       setLogos(res.data.data);
//   }

//   useEffect(() => {
//     const fetchAllLogos = async () => {
//       await getAllLogos();
//     };
//     fetchAllLogos();
//   }, []);

//   return (
//     <Stack spacing={1}>
//       <Box
//         ref={boxRef}
//         sx={{
//           border: '1px solid #ccc',
//           borderRadius: 1,
//           padding: '0 0 0 5px',
//           display: 'flex',
//           alignItems: 'center',
//           flexWrap: 'wrap',
//           minHeight: '45px',
//           position: 'relative',
//         }}
//       >
//         <DragDropContext onDragEnd={handleDragEnd}>
//           <Droppable droppableId="chips" direction="horizontal">
//             {(provided) => (
//               <Box
//                 ref={provided.innerRef}
//                 {...provided.droppableProps}
//                 sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, flexGrow: 1 }}
//               >
//                 {selectedLogos.map((sig, index) => (
//                   <Draggable key={sig.stored_filename} draggableId={sig.stored_filename} index={index}>
//                     {(provided) => (
//                       <Chip
//                         label={sig.name}
//                         onDelete={() => handleDelete(sig.stored_filename)}
//                         ref={provided.innerRef}
//                         {...provided.draggableProps}
//                         {...provided.dragHandleProps}
//                       />
//                     )}
//                   </Draggable>
//                 ))}
//                 {provided.placeholder}
//               </Box>
//             )}
//           </Droppable>
//         </DragDropContext>

//         <IconButton onClick={handleIconClick}>
//           <ArrowDropDownIcon />
//         </IconButton>
//       </Box>

//       <Menu
//         anchorEl={anchorEl}
//         open={Boolean(anchorEl)}
//         onClose={handleMenuClose}
//         PaperProps={{
//           style: {
//             width: boxRef.current ? boxRef.current.offsetWidth : undefined
//           }
//         }}
//         anchorOrigin={{
//           vertical: 'bottom',
//           horizontal: 'left'
//         }}
//         transformOrigin={{
//           vertical: 'top',
//           horizontal: 'left'
//         }}
//       >
//         {logos.map((logo) => (
//           <MenuItem key={logo.stored_filename} onClick={() => handleSelect(logo)}>
//             {logo.name}
//           </MenuItem>
//         ))}
//       </Menu>
//     </Stack>
//   );
// };

// export default LogoSelection;

import { Box, Chip, IconButton, Menu, MenuItem, Stack } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useState, useRef, useEffect } from 'react';
import { baseURL } from "../Constant";
import axios from 'axios';
import "./LogoSelection.css";
const LogoSelection = ({
  selectedLogos,
  setSelectedLogos
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const boxRef = useRef(null);
  const [logos, setLogos] = useState([]);
  const handleIconClick = () => {
    setAnchorEl(prev => prev ? null : boxRef.current); // Toggle dropdown
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleSelect = logo => {
    const exists = selectedLogos.some(s => s.stored_filename === logo.stored_filename);
    if (!exists) {
      setSelectedLogos([...selectedLogos, logo]);
    }
  };
  const handleDelete = id => {
    setSelectedLogos(selectedLogos.filter(sig => sig.stored_filename !== id));
  };
  const handleDragEnd = result => {
    if (!result.destination) return;
    const updated = [...selectedLogos];
    const [moved] = updated.splice(result.source.index, 1);
    updated.splice(result.destination.index, 0, moved);
    setSelectedLogos(updated);
  };
  async function getAllLogos() {
    try {
      const res = await axios.get(`${baseURL}/pptx/logos`);
      setLogos(res.data.data || []);
    } catch (error) {
      console.error("Failed to fetch logos:", error);
    }
  }
  useEffect(() => {
    getAllLogos();
  }, []);
  return <Stack spacing={1}>
      {/* Selected Logos as Chips */}
      <Box ref={boxRef} sx={{
      border: '1px solid #ccc',
      borderRadius: 1,
      padding: '0 0 0 5px',
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      minHeight: '45px',
      position: 'relative'
    }}>
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="chips" direction="horizontal">
            {provided => <Box ref={provided.innerRef} {...provided.droppableProps} sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 0.5,
            flexGrow: 1
          }}>
                {selectedLogos.map((logo, index) => <Draggable key={logo.stored_filename} draggableId={logo.stored_filename} index={index}>
                    {provided => <Chip label={logo.name} onDelete={() => handleDelete(logo.stored_filename)} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} />}
                  </Draggable>)}
                {provided.placeholder}
              </Box>}
          </Droppable>
        </DragDropContext>

        <IconButton onClick={handleIconClick}>
          <ArrowDropDownIcon />
        </IconButton>
      </Box>

      {/* Dropdown Menu */}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose} PaperProps={{
      style: {
        width: boxRef.current ? boxRef.current.offsetWidth : undefined
      }
    }} anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left'
    }} transformOrigin={{
      vertical: 'top',
      horizontal: 'left'
    }}>
        {logos.map(logo => {
        const isSelected = selectedLogos.some(s => s.stored_filename === logo.stored_filename);
        return <MenuItem key={logo.stored_filename} onClick={() => handleSelect(logo)} selected={isSelected} // ✅ highlights
        disabled={isSelected} // ✅ prevents duplicate selection
        sx={{
          opacity: "unset !important"
        }}>
              {logo.name}
              {isSelected && <span className="migrated-style-logoselection-d04dcd-1">✔</span>}
            </MenuItem>;
      })}
      </Menu>
    </Stack>;
};
export default LogoSelection;
